import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const MbpThreeForm = () => {

    const [entries, setEntries] = useState(() => {
        const saved = localStorage.getItem("mbp3_register_data");
        return saved ? JSON.parse(saved) : [{ id: Date.now() }];
    });

    useEffect(() => {
        localStorage.setItem("mbp3_register_data", JSON.stringify(entries));
    }, [entries]);

    const updateField = (id, field, value) => {
        setEntries(prev =>
            prev.map(entry =>
                entry.id === id ? { ...entry, [field]: value } : entry
            )
        );
    };

    const addEntry = () => setEntries([...entries, { id: Date.now() }]);
    const deleteEntry = (id) => {
        if (entries.length > 1) {
            setEntries(entries.filter(e => e.id !== id));
        }
    };

    const [signatureInfo, setSignatureInfo] = useState(() => {
        const saved = localStorage.getItem("mbp3_signature_info");
        return saved ? JSON.parse(saved) : { signature: "", date: "" };
    });

    const updateSignature = (field, value) => {
        const updated = { ...signatureInfo, [field]: value };
        setSignatureInfo(updated);
        localStorage.setItem("mbp3_signature_info", JSON.stringify(updated));
    };

const saveData = () => {
    const payload = {
        registerName: "MBP-3",
        signatureInfo: {
            signature: signatureInfo.signature || "",
            date: signatureInfo.date || ""
        },
        entries: entries.map(e => ({
            id: e.id || "",
            sNo: e.sNo || "",
            resolutionDate: e.resolutionDate || "",
            investDate: e.investDate || "",
            holderName: e.holderName || "",
            holderContact: e.holderContact || "",
            purpose: e.purpose || "",
            companyInvested: e.companyInvested || "",
            securityClass: e.securityClass || "",
            securityCount: e.securityCount || "",
            dpId: e.dpId || "",
            faceValue: e.faceValue || "",
            paidValue: e.paidValue || "",
            costAcquisition: e.costAcquisition || "",
            disposalDate: e.disposalDate || "",
            disposedCount: e.disposedCount || "",
            saleAmount: e.saleAmount || "",
            balanceSec: e.balanceSec || "",
            remarks: e.remarks || ""
        }))
    };

    console.log("MBP-3 PAYLOAD:");
    console.log(JSON.stringify(payload, null, 2));
};

    return (
        <div>
            <div className="bg-white px-6 py-2 mb-4 border-b-4 rounded-lg shadow text-center">
                <h1 className="text-2xl text-gray-900 uppercase">Form MBP - 3</h1>
                <h2 className="text-lg font-semibold mt-1">
                    Register of investments not held in its own name by the company
                </h2>
                <p className="text-xs mt-1 text-gray-500 italic">
                    [Pursuant to section 187(3) and rule 14(1)]
                </p>
            </div>

            <div className="space-y-10">
                {entries.map((entry, idx) => (
                    <div key={entry.id} className="bg-white rounded-lg shadow border">

                        <div className="bg-primary text-white px-6 py-2 flex justify-between items-center">
                            <span className="text-xs font-bold">Entry #{idx + 1}</span>
                            {entries.length > 1 && (
                                <button
                                    onClick={() => deleteEntry(entry.id)}
                                    className="text-[10px] bg-red-600 px-2 py-1 rounded hover:bg-red-700 uppercase"
                                >
                                    Remove
                                </button>
                            )}
                        </div>

                        <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-6">

                            <FormField label="(1) S. No." value={entry.sNo} onChange={(v)=>updateField(entry.id,"sNo",v)} />
                            <FormField type="date" label="(2) Board resolution date" value={entry.resolutionDate} onChange={(v)=>updateField(entry.id,"resolutionDate",v)} />
                            <FormField type="date" label="(3) Date of investment" value={entry.investDate} onChange={(v)=>updateField(entry.id,"investDate",v)} />

                            <FormField label="(4) Holder name" value={entry.holderName} onChange={(v)=>updateField(entry.id,"holderName",v)} />
                            <FormField type="description" label="(5) Address & Email" value={entry.holderContact} onChange={(v)=>updateField(entry.id,"holderContact",v)} />
                            <FormField type="description" label="(6) Purpose of investment" value={entry.purpose} onChange={(v)=>updateField(entry.id,"purpose",v)} />

                            <FormField label="(7) Invested entity" value={entry.companyInvested} onChange={(v)=>updateField(entry.id,"companyInvested",v)} />
                            <FormField label="(8) Class of securities" value={entry.securityClass} onChange={(v)=>updateField(entry.id,"securityClass",v)} />
                            <FormField label="(9) Number of securities" value={entry.securityCount} onChange={(v)=>updateField(entry.id,"securityCount",v)} />

                            <FormField label="(10) Client ID/DP No." value={entry.dpId} onChange={(v)=>updateField(entry.id,"dpId",v)} />
                            <FormField label="(11) Face value" value={entry.faceValue} onChange={(v)=>updateField(entry.id,"faceValue",v)} />
                            <FormField label="(12) Paid-up value" value={entry.paidValue} onChange={(v)=>updateField(entry.id,"paidValue",v)} />

                            <FormField label="(13) Cost of acquisition" value={entry.costAcquisition} onChange={(v)=>updateField(entry.id,"costAcquisition",v)} />
                            <FormField type="date" label="(14) Date of disposal" value={entry.disposalDate} onChange={(v)=>updateField(entry.id,"disposalDate",v)} />
                            <FormField label="(15) Securities disposed" value={entry.disposedCount} onChange={(v)=>updateField(entry.id,"disposedCount",v)} />

                            <FormField label="(16) Sale consideration" value={entry.saleAmount} onChange={(v)=>updateField(entry.id,"saleAmount",v)} />
                            <FormField label="(17) Balance securities" value={entry.balanceSec} onChange={(v)=>updateField(entry.id,"balanceSec",v)} />
                            <FormField type="description" label="(18) Remarks" value={entry.remarks} onChange={(v)=>updateField(entry.id,"remarks",v)} />

                        </div>
                    </div>
                ))}
            </div>

            <Button
            label='Add New Entry'
                onClick={addEntry}
                className="mt-2"
            />
                
            <div className="mt-2 bg-white p-5 rounded-lg shadow grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormField label="Signature (MD/Director/Secretary)" value={signatureInfo.signature} onChange={(v)=>updateSignature("signature",v)} />
                <FormField type="date" label="Date" value={signatureInfo.date} onChange={(v)=>updateSignature("date",v)} />
            </div>
<Button
    label="SAVE"
    onClick={saveData}
    className="mt-2"
/>

        </div>
    );
};

export default MbpThreeForm;
